/* ==========================================================================
   Next Journey Spa — Custom JS (no third-party libraries)
   ========================================================================== */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasIO = "IntersectionObserver" in window;

  /* ------------------------------------------------------------------
     Review content (Reviews Section / node 6-1124)

     ⚠️ PLACEHOLDER COPY. The reviews drawn in Figma were pasted in from a
     different project (an audit firm) and must not ship. These stand-ins are
     spa-appropriate but invented. Replace them with the real Google reviews
     for Next Journey Spa — this array is the single place to do it.
  ------------------------------------------------------------------ */
  var REVIEWS = [
    {
      name: "Sarah Jenkins",
      role: "",
      time: "5 days ago",
      rating: 4.5,
      avatar: "#4338ca",
      body: "Amazing deep tissue massage! The therapist focusedperfectly on my tight shoulders. The Marina Walk location is super convenient and the spa is very clean."
    },
    {
      name: "Ahmed Al-Mansoor",
      role: "",
      time: "1 week ago",
      rating: 5,
      avatar: "#ea580c",
      body: "Highly recommended Moroccan bath! Great thorough scrubbing, and the steam room was perfectly heated. Very clean and welcomingplace"
    },
    {
      name: "Priya Sharma ",
      role: "",
      time: "1 week ago",
      rating: 5,
      avatar: "#0f766e",
      body: "Loved the hot stonemassage! Pure bliss and very peaceful ambiance"
    },
    {
      name: "Dmitry Volkov ",
      role: "",
      time: "3 weeks ago",
      rating: 4.5,
      avatar: "#b91c1c",
      body: "Excellent Thai massage with good stretching and strong pressure.Clean environment. Finding parking at Marina Hotel Apartments can be tough, but the massageisworth it."
    },
    {
      name: "Michelle",
      role: "",
      time: "1 month ago",
      rating: 5,
      avatar: "#7c3aed",
      body: "Fantastic foot massage! Perfect after walking aroundtheMarina Walk. Friendly staff."
    },
    {
      name: "Yasmin El-Amin ",
      role: "",
      time: "2 months ago",
      rating: 5,
      avatar: "#0f766e",
      body: "Lovely hot oil massage. The oil was warm, the room was cozy, and the pressure wasexactly whatI wanted. Extremely professional team."
    },
    {
      name: "Fatima Al-Balushi",
      role: "",
      time: "3 months ago",
      rating: 5,
      avatar: "#ea580c",
      body: "My sister and I tried the Moroccan bath followed by Aroma therapy. We left feeling completely refreshed. Very polite therapists and clean facilities."
    },
    {
      name: "Marcus ",
      role: "",
      time: "3 months ago",
      rating: 5,
      avatar: "#7c3aed",
      body: "Tranquil couple's massage. Beautiful setup and synchronized treatments"
    }
  ];

  /* ------------------------------------------------------------------
     Scroll reveals (AOS-style, dependency-free)

     Any [data-aos] element starts hidden in CSS and is revealed when it
     scrolls into view. Direction comes from the attribute value; per-element
     stagger from [data-aos-delay] (ms).
     - One IntersectionObserver drives every element (no per-element polling).
     - Reveals once, then unobserves. GPU-friendly: opacity/transform only.
     - Reduced-motion or no IO support -> everything shown instantly.
  ------------------------------------------------------------------ */
  function initScrollReveal() {
    var els = document.querySelectorAll("[data-aos]");
    if (!els.length) return;

    function revealNow(el) {
      el.classList.add("aos-in");
    }

    if (prefersReduced || !hasIO) {
      Array.prototype.forEach.call(els, revealNow);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = el.getAttribute("data-aos-delay");
          if (delay) el.style.transitionDelay = delay + "ms";
          revealNow(el);
          obs.unobserve(el);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    Array.prototype.forEach.call(els, function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Stat counters (Stats band / node 6-846)

     Count up from 0 to the target when the band scrolls into view.
     The markup already contains the final value, so the section is correct
     with JS disabled and reduced-motion users see the value immediately.
  ------------------------------------------------------------------ */
  function initStatCounters() {
    var counters = document.querySelectorAll(".stat__number[data-count]");
    if (!counters.length) return;

    var DURATION = 1800; // ms

    function render(el, value) {
      el.textContent = value + (el.dataset.suffix || "");
    }

    function animate(el) {
      var target = parseInt(el.dataset.count, 10) || 0;
      var startTime = null;

      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / DURATION, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
        render(el, Math.round(eased * target));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          render(el, target); // guarantee the exact final value
        }
      }
      window.requestAnimationFrame(step);
    }

    if (prefersReduced || !hasIO) return; // markup already shows the finals

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animate(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    Array.prototype.forEach.call(counters, function (el) {
      render(el, 0); // reset before it comes into view
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Reviews marquee (Reviews Section / node 6-1124)

     Render the cards from REVIEWS, then clone the set once so the CSS
     translateX(-50%) loop is seamless. Clones are aria-hidden and unfocusable.
     Reduced-motion users get a static, horizontally scrollable strip.
  ------------------------------------------------------------------ */
  function initReviewsMarquee() {
    var track = document.querySelector("[data-reviews-track]");
    if (!track || !REVIEWS.length) return;

    // Scroll speed, in pixels per second. The duration is derived from the
    // track's real width so the cards always drift at the same pace no matter
    // how many reviews the array holds.
    var SPEED = 40;

    function escapeHTML(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    // 5 stars: full, then a half if the rating has one, then blanks.
    function starsHTML(rating) {
      var out = "";
      for (var i = 1; i <= 5; i++) {
        if (rating >= i) {
          out += '<img src="' + ((window.NJS_ASSETS && window.NJS_ASSETS["star.svg"]) || "star-pm.svg") + '" alt="" width="14" height="13" loading="lazy" />';
        } else if (rating >= i - 0.5) {
          out += '<img src="' + ((window.NJS_ASSETS && window.NJS_ASSETS["star-half.svg"]) || "star-half-pm.svg") + '" alt="" width="14" height="13" loading="lazy" />';
        }
      }
      return out;
    }

    function cardHTML(r) {
      return (
        '<li class="review-card">' +
          '<div class="review-card__head">' +
            '<span class="review-card__avatar" style="--avatar-bg:' + r.avatar + '" aria-hidden="true">' +
              escapeHTML(r.name.charAt(0)) +
              '<span class="review-card__badge">' +
                
              "</span>" +
            "</span>" +
            '<span class="review-card__who">' +
              '<span class="review-card__name">' +
                '<span class="review-card__name-text">' + escapeHTML(r.name) + "</span>"  +
              "</span>" +
              '<span class="review-card__role">' + escapeHTML(r.role) + "</span>" +
              '<span class="review-card__time">' + escapeHTML(r.time) + "</span>" +
            "</span>" +
          "</div>" +
          '<div class="review-card__stars" role="img" aria-label="Rated ' + r.rating + ' out of 5">' +
            starsHTML(r.rating) +
          "</div>" +
          '<p class="review-card__body">' + escapeHTML(r.body) + "</p>" +
          '<div class="review-card__foot">' +
          "</div>" +
        "</li>"
      );
    }

    track.innerHTML = REVIEWS.map(cardHTML).join("");

    // Reduced motion: no auto-scroll. Leave a static, manually scrollable strip.
    if (prefersReduced) {
      track.parentElement.style.overflowX = "auto";
      return;
    }

    // Clone the set once so translateX(-50%) lands exactly on the seam.
    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      Array.prototype.forEach.call(clone.querySelectorAll("a, button"), function (el) {
        el.setAttribute("tabindex", "-1");
      });
      track.appendChild(clone);
    });

    // Duration = distance travelled (half the doubled track) ÷ speed.
    var distance = track.scrollWidth / 2;
    track.style.setProperty("--marquee-duration", Math.round(distance / SPEED) + "s");

    track.classList.add("is-animated");
  }

  /* ------------------------------------------------------------------
     Mobile navigation

     Not in the Figma design — required for the page to work below 1024px.
     Hamburger toggles a slide-in panel: aria-expanded is kept in sync, Esc
     closes it, focus is trapped while it is open and restored on close.
  ------------------------------------------------------------------ */
  function initMobileNav() {
    var toggle = document.getElementById("nav-toggle");
    var panel = document.getElementById("nav-links");
    var scrim = document.getElementById("nav-scrim");
    var closeBtn = document.getElementById("nav-close");
    if (!toggle || !panel || !scrim) return;

    var lastFocused = null;

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll("a[href], button:not([disabled])"),
        function (el) {
          if (el.offsetParent === null) return false;
          // Service links inside a collapsed dropdown are not reachable.
          var menu = el.closest(".dropdown__menu");
          return !menu || menu.parentElement.classList.contains("is-open");
        }
      );
    }

    function open() {
      lastFocused = document.activeElement;
      panel.classList.add("is-open");
      scrim.classList.add("is-open");
      scrim.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      // Locks the page behind the panel and un-blurs the sticky bar — see § 14.
      document.documentElement.classList.add("is-nav-open");

      var first = focusables()[0];
      if (first) first.focus();
    }

    function close() {
      panel.classList.remove("is-open");
      scrim.classList.remove("is-open");
      scrim.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      document.documentElement.classList.remove("is-nav-open");

      if (lastFocused) lastFocused.focus();
      else toggle.focus();
    }

    function isOpen() {
      return toggle.getAttribute("aria-expanded") === "true";
    }

    toggle.addEventListener("click", function () {
      if (isOpen()) close();
      else open();
    });

    // The close button is the way out. The scrim only dims the page behind the
    // panel — clicking it deliberately does nothing, so the menu can't be
    // dismissed by a stray tap. (Esc still works; a modal that traps focus with
    // no keyboard escape would be a trap in the literal sense.)
    if (closeBtn) closeBtn.addEventListener("click", close);

    // Tapping a link inside the panel navigates and closes it.
    panel.addEventListener("click", function (e) {
      if (e.target.closest("a") && isOpen()) close();
    });

    document.addEventListener("keydown", function (e) {
      if (!isOpen()) return;

      if (e.key === "Escape") {
        close();
        return;
      }

      if (e.key !== "Tab") return;

      // Trap focus inside the panel.
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Leaving the mobile breakpoint with the panel open would strand the scrim.
    var mq = window.matchMedia("(min-width: 1025px)");
    var onChange = function (e) {
      if (e.matches && isOpen()) close();
    };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange); // Safari < 14
  }

  /* ------------------------------------------------------------------
     Services dropdown (node 6-1278)

     The panel itself is pure CSS (§ 8.1) — opacity + transform, so it opens
     and closes smoothly. This only flips .is-open and keeps the ARIA and the
     keyboard in step:
       - desktop: hover opens (with a short grace period on the way out);
         click and Enter/Space work too
       - ≤1024px, inside the slide-in panel: click/tap only
       - arrows walk the items, Esc closes and returns focus to the trigger,
         Tab out or a click anywhere else closes it
  ------------------------------------------------------------------ */
  var HOVER_CLOSE_DELAY = 160; // ms of grace when the pointer leaves

  function initDropdowns() {
    var roots = document.querySelectorAll("[data-dropdown]");
    if (!roots.length) return;

    var desktop = window.matchMedia("(min-width: 1025px)");

    Array.prototype.forEach.call(roots, function (root) {
      var toggle = root.querySelector("[data-dropdown-toggle]");
      var menu = root.querySelector(".dropdown__menu");
      if (!toggle || !menu) return;

      var hoverTimer = null;

      function items() {
        return Array.prototype.slice.call(menu.querySelectorAll(".dropdown__item"));
      }
      function isOpen() {
        return root.classList.contains("is-open");
      }
      function open() {
        root.classList.add("is-open");
        toggle.setAttribute("aria-expanded", "true");
      }
      function close() {
        root.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }

      toggle.addEventListener("click", function () {
        if (isOpen()) close();
        else open();
      });

      toggle.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowDown" && e.key !== "Down") return;
        e.preventDefault();
        open();
        var first = items()[0];
        if (first) first.focus();
      });

      root.addEventListener("mouseenter", function () {
        if (!desktop.matches) return;
        window.clearTimeout(hoverTimer);
        open();
      });
      root.addEventListener("mouseleave", function () {
        if (!desktop.matches) return;
        hoverTimer = window.setTimeout(close, HOVER_CLOSE_DELAY);
      });

      menu.addEventListener("keydown", function (e) {
        var list = items();
        var i = list.indexOf(document.activeElement);

        if (e.key === "ArrowDown" || e.key === "Down") {
          e.preventDefault();
          (list[i + 1] || list[0]).focus();
        } else if (e.key === "ArrowUp" || e.key === "Up") {
          e.preventDefault();
          (list[i - 1] || list[list.length - 1]).focus();
        } else if (e.key === "Escape") {
          close();
          toggle.focus();
        } else if (e.key === "Tab") {
          close();
        }
      });

      // Choosing a service closes the panel behind you.
      menu.addEventListener("click", function (e) {
        if (e.target.closest(".dropdown__item")) close();
      });

      document.addEventListener("click", function (e) {
        if (isOpen() && !root.contains(e.target)) close();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && isOpen()) {
          close();
          toggle.focus();
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Services select (node 6-1278, inside both enquiry forms)

     The markup ships a real <select required>: with JS off it still renders,
     validates and submits. Here we hide it (it stays the form's value carrier
     and the thing checkValidity() reads) and build the designed button +
     listbox on top, reusing the same .dropdown panel as the header.
  ------------------------------------------------------------------ */
  function initSelects() {
    var wraps = document.querySelectorAll("[data-select]");
    if (!wraps.length) return;

    var CARET =
      '<svg class="dropdown__caret" viewBox="0 0 10 6" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M1 1.25 5 4.75 9 1.25" stroke="currentColor" stroke-width="1.3" ' +
          'stroke-linecap="round" stroke-linejoin="round" />' +
      "</svg>";

    Array.prototype.forEach.call(wraps, function (wrap) {
      var native = wrap.querySelector("select");
      if (!native) return;

      var label = wrap.querySelector("label");
      var labelId = native.id + "-label";
      var buttonId = native.id + "-button";
      var menuId = native.id + "-menu";
      if (label) label.id = labelId;

      // The first <option> is the placeholder ("Services*"), never a choice.
      var choices = Array.prototype.filter.call(native.options, function (o) {
        return o.value !== "";
      });
      var placeholder = native.options.length ? native.options[0].textContent : "Select";

      // Trigger — inherits the form's field classes so it matches the inputs
      // beside it exactly (.field--pill in the hero, .field--soft in contact).
      var button = document.createElement("button");
      button.type = "button";
      button.id = buttonId;
      button.className =
        native.className.replace("select__native", "").trim() + " select__button";
      button.setAttribute("aria-haspopup", "listbox");
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-controls", menuId);
      if (label) button.setAttribute("aria-labelledby", labelId + " " + buttonId);
      button.innerHTML = '<span class="select__value"></span>' + CARET;

      var menu = document.createElement("ul");
      menu.className = "dropdown__menu select__menu";
      menu.id = menuId;
      menu.setAttribute("role", "listbox");
      if (label) menu.setAttribute("aria-labelledby", labelId);
      // No row chevron here — that belongs to the header menu only. In a form
      // the row is a choice, not a link onward.
      menu.innerHTML = choices
        .map(function (o, i) {
          return (
            '<li role="presentation">' +
              '<div class="dropdown__item" role="option" tabindex="-1" ' +
                'id="' + native.id + "-opt-" + i + '" aria-selected="false" ' +
                'data-value="' + o.value.replace(/"/g, "&quot;") + '">' +
                "<span>" + o.textContent + "</span>" +
              "</div>" +
            "</li>"
          );
        })
        .join("");

      wrap.appendChild(button);
      wrap.appendChild(menu);
      wrap.classList.add("select--enhanced");

      // The native select stays in the form but leaves the tab order and the
      // accessibility tree — the button speaks for it now.
      native.setAttribute("tabindex", "-1");
      native.setAttribute("aria-hidden", "true");

      var valueEl = button.querySelector(".select__value");
      var options = Array.prototype.slice.call(menu.querySelectorAll(".dropdown__item"));

      function isOpen() {
        return wrap.classList.contains("is-open");
      }
      function open() {
        wrap.classList.add("is-open");
        button.setAttribute("aria-expanded", "true");
        var current = options.filter(function (o) {
          return o.getAttribute("aria-selected") === "true";
        })[0];
        (current || options[0]).focus();
      }
      function close(refocus) {
        wrap.classList.remove("is-open");
        button.setAttribute("aria-expanded", "false");
        if (refocus) button.focus();
      }

      // Paint the button + list from whatever the native select currently holds.
      function sync() {
        var value = native.value;
        valueEl.textContent = value || placeholder;
        wrap.classList.toggle("has-value", !!value);
        options.forEach(function (o) {
          var on = o.dataset.value === value;
          o.setAttribute("aria-selected", on ? "true" : "false");
          o.classList.toggle("is-active", on);
        });
      }

      function choose(option) {
        native.value = option.dataset.value;
        native.dispatchEvent(new Event("change", { bubbles: true }));
        button.setAttribute("aria-invalid", "false");
        sync();
        close(true);
      }

      button.addEventListener("click", function () {
        if (isOpen()) close(false);
        else open();
      });
      button.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || e.key === "Down" || e.key === "ArrowUp" || e.key === "Up") {
          e.preventDefault();
          open();
        }
      });

      menu.addEventListener("click", function (e) {
        var option = e.target.closest(".dropdown__item");
        if (option) choose(option);
      });

      menu.addEventListener("keydown", function (e) {
        var i = options.indexOf(document.activeElement);

        if (e.key === "ArrowDown" || e.key === "Down") {
          e.preventDefault();
          (options[i + 1] || options[0]).focus();
        } else if (e.key === "ArrowUp" || e.key === "Up") {
          e.preventDefault();
          (options[i - 1] || options[options.length - 1]).focus();
        } else if (e.key === "Home") {
          e.preventDefault();
          options[0].focus();
        } else if (e.key === "End") {
          e.preventDefault();
          options[options.length - 1].focus();
        } else if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          if (i > -1) choose(options[i]);
        } else if (e.key === "Escape") {
          e.preventDefault();
          close(true);
        } else if (e.key === "Tab") {
          close(false);
        }
      });

      document.addEventListener("click", function (e) {
        if (isOpen() && !wrap.contains(e.target)) close(false);
      });

      // initForms() calls form.reset() on a successful submit — put the button
      // back to "Services*" once the native select has actually reset.
      if (native.form) {
        native.form.addEventListener("reset", function () {
          window.setTimeout(function () {
            button.setAttribute("aria-invalid", "false");
            sync();
          }, 0);
        });
      }

      sync();
    });
  }

  /* ------------------------------------------------------------------
     Services carousel (Signature services / node 6-867)

     An infinite, one-card-at-a-time carousel, hand-rolled — no library.

     The loop: the leading --per-view slides are cloned onto the end of the
     track, so there is always a card waiting to the right. The track eases one
     card left; when the index reaches the end of the real set it is snapped
     back to 0 with the transition off, which lands on the identical clones —
     the rewind is invisible. Going back past the first card does the same trick
     in reverse: jump silently to the seam, then animate one card left.

     Manual control (arrows, dots, drag/swipe) moves the same one-card step and
     parks the autoplay; it restarts a few seconds after you stop touching it.
     Hovering, focusing inside, or backgrounding the tab pauses it outright.
     Reduced motion: no autoplay at all, and the manual moves are instant.
  ------------------------------------------------------------------ */
  function initCarousels() {
    var roots = document.querySelectorAll("[data-carousel]");
    if (!roots.length) return;

    var AUTOPLAY = 3500; // ms a card rests before the next one comes
    var RESUME = 6000;   // ms of quiet after a manual move before autoplay resumes
    var DRAG_RATIO = 0.2; // fraction of a card you must drag to commit to the move

    Array.prototype.forEach.call(roots, function (root) {
      var track = root.querySelector("[data-carousel-track]");
      var viewport = root.querySelector(".carousel__viewport");
      var controls = root.querySelector("[data-carousel-controls]");
      var dotsBox = root.querySelector("[data-carousel-dots]");
      var prevBtn = root.querySelector("[data-carousel-prev]");
      var nextBtn = root.querySelector("[data-carousel-next]");
      if (!track || !viewport) return;

      var slides = Array.prototype.slice.call(track.children);
      var count = slides.length;
      if (count < 2) return;

      var clones = [];
      var index = 0;
      var timer = null;
      var resumeTimer = null;
      var paused = false;

      /* --- geometry ---------------------------------------------------- */

      // --per-view lives in the CSS (§ 18) and changes at the breakpoints;
      // reading it back keeps the two from drifting apart.
      function perView() {
        var v = parseInt(
          window.getComputedStyle(root).getPropertyValue("--per-view"),
          10
        );
        return Math.max(1, Math.min(v || 1, count));
      }

      // One card plus one gap — the distance a single step travels.
      function stepWidth() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }

      function move(animate) {
        track.classList.toggle("is-sliding", !!animate);
        track.style.transform = "translateX(" + -index * stepWidth() + "px)";
      }

      // Land on `to` with no transition, then let the caller animate from there.
      function jumpTo(to) {
        index = to;
        move(false);
        track.getBoundingClientRect(); // flush, so the next move really animates
      }

      /* --- the loop ----------------------------------------------------- */

      function build() {
        clones.forEach(function (clone) { track.removeChild(clone); });
        clones = [];

        var n = perView();
        for (var i = 0; i < n; i++) {
          var clone = slides[i].cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          // The clone is decoration: it must not be read out, tabbed into, or
          // wait on a scroll reveal that will never fire for it.
          clone.removeAttribute("data-aos");
          clone.removeAttribute("data-aos-delay");
          Array.prototype.forEach.call(clone.querySelectorAll("a, button"), function (el) {
            el.setAttribute("tabindex", "-1");
          });
          clones.push(clone);
          track.appendChild(clone);
        }

        if (index >= count) index = 0;
        move(false);
        syncDots();
      }

      function next() {
        index++;
        move(true);
        syncDots();
      }

      function prev() {
        if (index === 0) jumpTo(count); // the seam — visually identical to 0
        index--;
        move(true);
        syncDots();
      }

      function goTo(i) {
        if (i === index % count) return;
        index = i;
        move(true);
        syncDots();
      }

      // The only place the rewind happens: the step into the clones has just
      // finished, so swapping to the real first card cannot be seen.
      track.addEventListener("transitionend", function (e) {
        // Card hover scales its photo — that transition bubbles up here too.
        if (e.target !== track || e.propertyName !== "transform") return;
        if (index >= count) {
          index = 0;
          move(false);
        }
      });

      /* --- autoplay ------------------------------------------------------ */

      function play() {
        stop();
        if (prefersReduced) return;
        timer = window.setInterval(function () {
          if (!paused) next();
        }, AUTOPLAY);
      }
      function stop() {
        window.clearInterval(timer);
        timer = null;
      }
      // A manual move owns the carousel for a while; autoplay backs off.
      function manual(fn) {
        stop();
        window.clearTimeout(resumeTimer);
        fn();
        resumeTimer = window.setTimeout(play, RESUME);
      }

      root.addEventListener("mouseenter", function () { paused = true; });
      root.addEventListener("mouseleave", function () { paused = false; });
      root.addEventListener("focusin", function () { paused = true; });
      root.addEventListener("focusout", function () { paused = false; });
      document.addEventListener("visibilitychange", function () {
        paused = document.hidden;
      });

      /* --- controls ------------------------------------------------------ */

      if (prevBtn) prevBtn.addEventListener("click", function () { manual(prev); });
      if (nextBtn) nextBtn.addEventListener("click", function () { manual(next); });

      function buildDots() {
        if (!dotsBox) return;
        dotsBox.innerHTML = "";
        slides.forEach(function (slide, i) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "carousel__dot";
          dot.setAttribute("aria-current", i === 0 ? "true" : "false");

          var title = slide.querySelector(".service-card__title");
          dot.setAttribute(
            "aria-label",
            title ? "Show " + title.textContent.trim() : "Show slide " + (i + 1)
          );

          dot.addEventListener("click", function () {
            manual(function () { goTo(i); });
          });
          dotsBox.appendChild(dot);
        });
      }

      function syncDots() {
        if (!dotsBox) return;
        var active = index % count;
        Array.prototype.forEach.call(dotsBox.children, function (dot, i) {
          dot.setAttribute("aria-current", i === active ? "true" : "false");
        });
      }

      /* --- drag / swipe --------------------------------------------------- */

      var dragging = false;
      var startX = 0;
      var startOffset = 0;
      var travelled = 0;

      function swallowClick(e) {
        e.preventDefault();
        e.stopPropagation();
      }

      viewport.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        dragging = true;
        travelled = 0;
        startX = e.clientX;
        startOffset = -index * stepWidth();
        track.classList.add("is-dragging");
        track.classList.remove("is-sliding");
        stop();
      });

      window.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        travelled = e.clientX - startX;
        track.style.transform = "translateX(" + (startOffset + travelled) + "px)";
      });

      window.addEventListener("pointerup", function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove("is-dragging");

        var threshold = stepWidth() * DRAG_RATIO;
        if (travelled <= -threshold) next();
        else if (travelled >= threshold) prev();
        else move(true); // not far enough — spring back

        // A drag that ends on a card must not also follow that card's link.
        if (Math.abs(travelled) > 5) {
          track.addEventListener("click", swallowClick, true);
          window.setTimeout(function () {
            track.removeEventListener("click", swallowClick, true);
          }, 0);
        }

        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(play, RESUME);
      });

      /* --- go ------------------------------------------------------------- */

      var resizeTimer = null;
      window.addEventListener("resize", function () {
        window.clearTimeout(resizeTimer);
        // Rebuild rather than re-measure: --per-view may have crossed a
        // breakpoint, which changes both the card width and the clone count.
        resizeTimer = window.setTimeout(build, 150);
      });

      buildDots();
      build();
      root.classList.add("is-ready");
      if (controls) controls.hidden = false;
      play();
    });
  }

  /* ------------------------------------------------------------------
     Featured service cards (node 6-1023)

     The hover overlay is pure CSS (§ 21). This exists only for touch screens,
     which have no hover to give: there, tapping a card reveals its overlay
     (and closes any other), and tapping outside puts it back. The buttons
     inside keep working normally — the tap that opens the card is not the tap
     that follows a link.
  ------------------------------------------------------------------ */
  function initFeaturedCards() {
    var cards = document.querySelectorAll(".featured-card");
    if (!cards.length) return;
    if (!window.matchMedia("(hover: none)").matches) return; // mouse: CSS has it

    function closeAll(except) {
      Array.prototype.forEach.call(cards, function (card) {
        if (card !== except) card.classList.remove("is-revealed");
      });
    }

    Array.prototype.forEach.call(cards, function (card) {
      card.addEventListener("click", function (e) {
        if (e.target.closest(".featured-card__overlay .btn")) return; // let it through
        closeAll(card);
        card.classList.toggle("is-revealed");
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".featured-card")) closeAll(null);
    });
  }

  /* ------------------------------------------------------------------
     Sticky header

     The design has a second, white/blurred header (node 6-751). It is
     rendered here as the scrolled state of the hero's own nav: add .is-stuck
     once the page has scrolled past the top bar. rAF-throttled — no layout
     thrashing, no work on every scroll event.
  ------------------------------------------------------------------ */
  function initStickyHeader() {
    var header = document.getElementById("site-header");
    if (!header) return;

    var ticking = false;

    // Hysteresis: it sticks at 88px but only lets go again at 40px. A single
    // threshold sits right on the edge of the transition, where a pixel of
    // momentum or rounding is enough to flip it back and forth.
    var STICK_AT = 88;   // px
    var RELEASE_AT = 40; // px

    function update() {
      var y = window.scrollY;
      var stuck = header.classList.contains("is-stuck");

      if (!stuck && y > STICK_AT) header.classList.add("is-stuck");
      else if (stuck && y < RELEASE_AT) header.classList.remove("is-stuck");

      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }


  function init() {
    initScrollReveal();
    initStatCounters();
    initReviewsMarquee();
    initMobileNav();
    initDropdowns();
    initSelects();
    initCarousels();
    initFeaturedCards();
    initStickyHeader();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

//floating form
document.addEventListener("DOMContentLoaded", function () {

    const wrapper = document.querySelector(".offcanvas_form_wrapper");
    const backdrop = document.querySelector(".offcanvas_backdrop");
    const body = document.body;
    const text = document.querySelector(".offcanvas_form_wrapper .offcanvas_btnwrapper .enq_text");

    document.querySelectorAll(".offcanvas_form_wrapper .offcanvas_btnwrapper, .offcanvas_form_wrapper .sec_head .offcanvas_xs_closebtn")
        .forEach(function (btn) {

            btn.addEventListener("click", function () {

                wrapper.classList.toggle("open");
                backdrop.classList.toggle("show");
                body.classList.toggle("noScroll__wr");

                text.textContent = wrapper.classList.contains("open")
                    ? "Close"
                    : "Enquiry";
            });

        });

});

//popover
document.addEventListener("click", function (e) {

    const button = e.target.closest(".floating");

    if (!button) return;

    if (window.innerWidth < 992) return;

    e.preventDefault();

    let popover;

    // Floating button
    const wrapper = button.closest(".callBtnWrap__wr");

    if (wrapper) {
        popover = wrapper.querySelector(".popoverWrap__wr");
    }
    // Other buttons
    else {
        popover = button.parentElement.querySelector(".popoverWrap__wr");
    }

    if (!popover) return;

    // Close all other popovers
    document.querySelectorAll(".popoverWrap__wr.active").forEach(function (item) {
        if (item !== popover) {
            item.classList.remove("active");
        }
    });

    // Toggle current popover
    popover.classList.toggle("active");
});